import react from "react";
import Loadable from "@loadable/component";
const LoadableEditor = Loadable(() => import("./editor"));
export default LoadableEditor;
